<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.aaTitle" style="width: 140px;" size="small" placeholder="请输入名称"
                        clearable></el-input>
                    <!-- 智能体类型 -->
                    <el-select v-model="formDatas.aatId" placeholder="请选择智能体类型" size="small" style="width: 140px;"
                        clearable @change="partserch">
                        <el-option v-for="item in getAiAppTypeList_data || []" :label="item.aatName"
                            :value="item.aatId" :key="item.aatId">
                        </el-option>
                    </el-select>
                    <!-- 智能体平台(1百度 2dify) -->
                    <el-select v-model="formDatas.aaAppPlatform" placeholder="请选择智能体平台" size="small"
                        style="width: 140px;" clearable @change="partserch">
                        <el-option label="百度" :value="1">
                        </el-option>
                        <el-option label="dify" :value="2">
                        </el-option>
                    </el-select>
                    <el-select v-model="formDatas.aaType" placeholder="请选择类型" size="small" style="width: 140px;"
                        clearable @change="partserch">
                        <el-option label="对话" :value="1"></el-option>
                        <el-option label="演练" :value="2"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.aaWord" placeholder="是否导出word" size="small" style="width: 140px;" 
                        clearable @change="partserch">
                        <el-option label="否" :value="1"></el-option>
                        <el-option label="是" :value="2"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="danger" size="small" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增智能体</el-button>

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="aaId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑智能体' : '新增智能体'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="智能体名称" prop="aaTitle">
                                <el-input v-model="form.aaTitle" style="width: 100%;" clearable
                                    placeholder="请输入名称"></el-input>
                            </el-form-item>
                            <el-form-item label="智能体id(appid)" prop="aaAppId">
                                <el-input v-model="form.aaAppId" style="width: 100%;" clearable
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="智能体接口地址" prop="aaAppBaseUrl">
                                <el-input v-model="form.aaAppBaseUrl" style="width: 100%;" clearable
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="智能体类型" prop="aatId">
                                <el-select v-model="form.aatId" placeholder="请选择智能体类型" style="width: 50%;" filterable
                                    clearable>
                                    <el-option v-for="item in getAiAppTypeList_data || []" :label="item.aatName"
                                        :value="item.aatId" :key="item.aatId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <!-- 智能体平台(1百度 2dify) -->
                            <el-form-item label="智能体平台" prop="aaAppPlatform">
                                <el-select v-model="form.aaAppPlatform" placeholder="请选择智能体平台" style="width: 50%;"
                                    filterable clearable>
                                    <el-option label="百度" :value="1">
                                    </el-option>
                                    <el-option label="dify" :value="2">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="对话类型" prop="aaType">
                                <el-select v-model="form.aaType" placeholder="请选择类型" style="width: 100%;" filterable
                                    clearable>
                                    <el-option label="对话" :value="1">
                                    </el-option>
                                    <el-option label="演练" :value="2">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="是否导出word" prop="aaWord">
                                <el-select v-model="form.aaWord" placeholder="请选择" style="width: 100%;" filterable
                                    clearable>
                                    <el-option label="否" :value="1">
                                    </el-option>
                                    <el-option label="是" :value="2">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="模型描述" prop="aaModelDes">
                                <el-input v-model="form.aaModelDes" clearable style="width: 100%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="智能体图标" prop="aaIcon">
                                <my-uploadTwo ref="OtherImgupload" @fileChange="OtherImgChange"
                                    :filearr="OtherImgfileList" :limit="2" style="margin: 10px 5px 5px;"
                                    @removeAfter="form.aaIcon = ''">
                                </my-uploadTwo>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>

        </div>
        <!--分配权限 -->
        <el-dialog title="知识库关联" :visible.sync="IsAuth" width="70%" top="8vh" :close-on-click-modal="false"
            :close-on-press-escape="false" @close="AuthHandleClose">
            <div style="width: 100%;display: flex;flex-direction: row-reverse;margin: 20px 0;">
                <el-button type="success" size="small" style="margin-right: 20px" @click="addAbout">新增关联</el-button>
            </div>
            <div>
                <ve-table ref="vetable2" v-if="AuthData" :columns="columnsAuth" :table-data="AuthData"
                    :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                    :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="akfId"
                    :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                <div v-show="AuthData.length == 0" class="empty-data">暂无数据</div>
            </div>
        </el-dialog>
        <el-dialog title="新增关联" :visible.sync="isAddBank" width="70%" top="8vh">
            <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                    <el-form-item label="知识库" prop="akwId">
                        <el-select v-model="formBank.akwId" placeholder="请选择知识库">
                            <el-option v-for="item in getAiKnowledgeWareList_data || []" :label="item.akwName"
                                :value="item.akwId" :key="item.akwId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
            <div class="demo-drawer__footer" style="margin-top: 10px;">
                <el-button @click="handleClose2()" style="margin-left: 20%;">取 消</el-button>
                <el-button type="primary" @click="SureBtn2" style="margin-left: 150px;">
                    确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import { getAiAppTypeList, getAiAppList, addAiApp, updateAiApp, deleteAiApp, getAiAppKnowledgeList, getAiKnowledgeWareList, deleteAiAppKnowledge, addAiAppKnowledge } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            getAiAppTypeList_data: [],
            isAddBank: false,
            formBank: {
                akcId: ''
            },
            getAiKnowledgeWareList_data: [],
            columnsAuth: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",

                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "akwName",
                    key: "akwName",
                    title: "知识库名称",
                    align: "center",
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.akwName}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDeleteAbout(row)}
                                >
                                    删除关联
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            AuthData: [],
            myRoleId: '',
            IsAuth: false,
            authTreeList: [],
            OtherImgfileList: [],
            key: 'aaId',
            dialog: false,
            edit: false,
            form: {
                appiName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",

                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "aaTitle",
                    key: "aaTitle",
                    title: "智能体名称",
                    align: "center",
                    width: 180,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.aaTitle}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "aaAppId",
                    key: "aaAppId",
                    title: "智能体id",
                    align: "center",
                    edit: false,
                    width: 240,
                },
                {
                    field: "aaAppBaseUrl",
                    key: "aaAppBaseUrl",
                    title: "智能体接口地址",
                    align: "center",
                    edit: false,
                    width: 200,
                },
                {
                    field: "aaModelDes",
                    key: "aaModelDes",
                    title: "智能体描述",
                    align: "center",
                    edit: false,
                    width: 110,
                },
                {
                    field: "aatName",
                    key: "aatName",
                    title: "智能体分类",
                    align: "center",
                    edit: false,
                    width: 110,
                },
                {
                    field: "aaAppPlatform",
                    key: "aaAppPlatform",
                    title: "智能体平台",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aaAppPlatform == 1 ? '百度' : row.aaAppPlatform == 2 ? 'dify' : ''
                                }
                            </span>
                        )
                    },
                    edit: false,
                },
                {
                    field: "aaType",
                    key: "aaType",
                    title: "对话类型",
                    align: "center",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aaType == 1 ? '对话' : row.aaType == 2 ? '演练' : ''
                                }
                            </span>
                        )
                    },
                    edit: false,
                },
                {
                    field: "aaWord",
                    key: "aaWord",
                    title: "是否导出word",
                    align: "center",
                    width: 110,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aaWord == 1 ? '否' : row.aaWord == 2 ? '是' : ''
                                }
                            </span>
                        )
                    },
                    edit: false,
                },
                {
                    field: "aaIcon",
                    key: "aaIcon",
                    title: "智能体图标",
                    align: "center",
                    edit: false,
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aaIcon ? <el-image ref="scrImg" id="scrimg" src={row.aaIcon.split(',')[0]} alt="" fit="fill" style="height: 80px;width: 80px;"
                                        previewSrcList={row.aaIcon.split(',')}></el-image> : <span></span>
                                }


                            </span>
                        );
                    },

                },

                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    fixed: "right",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.openBank(row)}
                                >
                                    关联知识库
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                appiType: 1,
                appiName: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAiAppTypeList().then(res => {
            this.getAiAppTypeList_data = res.data;
        });
        this.getList();
    },
    mounted() { },
    methods: {
        AuthHandleClose() {
            this.IsAuth = false;
        },
        handleDeleteAbout(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAiAppKnowledge({ aakId: row.aakId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.getList2()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleClose2() {
            this.isAddBank = false;
            this.formBank = {
                akwId: '',

            }
            this.$refs['formRef'].resetFields();
        },
        openBank(row) {
            getAiAppKnowledgeList({ aaId: row.aaId }).then(res => {
                this.AuthData = res.data;
                this.theRoleId = row.aaId
                this.IsAuth = true;
            })
        },
        SureBtn2() {
            this.$confirm("是否确定要新增, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const data = JSON.parse(JSON.stringify(this.formBank))
                    data.aaId = this.theRoleId
                    addAiAppKnowledge(data).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.handleClose2()
                            this.getList2()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        getList2() {
            getAiAppKnowledgeList({ aaId: this.theRoleId }).then(res => {
                this.AuthData = res.data;
            })
        },
        addAbout() {
            getAiKnowledgeWareList({ pageSize: 0 }).then(res => {
                this.getAiKnowledgeWareList_data = res.data;
                this.isAddBank = true;
            })
        },
        OtherImgChange(file) {
            console.log(file);
            this.$set(this.form, 'aaIcon', file[0])
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAiApp({ aaIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAiApp({ aaId: row.aaId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.aaIcon = data.aaIcon.split(',')
                console.log(this.form.aaIcon);
                if (this.form.aaIcon && this.form.aaIcon.length > 0) {
                    this.form.aaIcon.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.OtherImgfileList, index, img);
                        console.log(this.OtherImgfileList);

                    })

                }
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAiApp(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAiApp(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.OtherImgfileList = [];
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aaId = row.aaId
                    console.log(jsonObj);
                    updateAiApp(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAiAppList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAiAppList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAiAppList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>